/**
 * This function masks contact information, such as email addresses and phone numbers.
 * For emails, it masks the user part before the '@' and the domain name 
 * 
 * console.log(maskContactInfo("yogeshsingh@google.com")); -->Output y**********@g*****.com
 * 
 * console.log(maskContactInfo("+918439876543")); -->Output +91843****
 * 
 * console.log(maskContactInfo("8439876543"));   -->Output 8439****
*/
export function maskContactInfo(input) {
  if (!input) return "";

  if (input.includes("@")) {
    const [user, domain] = input.split("@");
    const maskedUser = user[0] + "*".repeat(user.length - 1);
    
    const domainName = domain.split(".")[0];
    const domainExt = domain.split(".").slice(1).join(".");
    const maskedDomain = domainName[0] + "*".repeat(domainName.length - 1);

    return `${maskedUser}@${maskedDomain}.${domainExt}`;
  }

  const digits = input.replace(/\D/g, "");
  if (digits.length >= 10) {
    const visiblePart = digits.length === 10 ? digits.slice(0, 4) : `+${digits.slice(0, 5)}`;
    return visiblePart + "****";
  }

  return input;
}

export const maskStatus = ["accept", "hired", "offer_sent", "offer_accept"]
